import { useEffect, useState } from 'react';

import lockIconWebp from '@wwe-portal/ui/assets/images/flagship/lock-icon.webp';

import { ItemIconWithToolTip } from '../offer-review/item-icon-tooltip';

export function LockIcon({
  orderId,
  enabled,
}: {
  orderId: number;
  enabled: boolean;
}) {
  const [localEnabled, setLocalEnabled] = useState<boolean>(enabled);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLocalEnabled(enabled);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [enabled]);

  if (!localEnabled) return null;
  return (
    <div
      className="absolute -right-1 bottom-1 inline-flex h-5 w-5 translate-x-[15%] translate-y-[15%] items-center justify-center rounded-full duration-500 ease-out data-[enabled=false]:opacity-0"
      data-enabled={enabled}
    >
      <ItemIconWithToolTip
        tooltipContent={`Purchase Item ${orderId - 1} to unlock`}
      >
        <img alt="locked" height="27" src={lockIconWebp} width="21" />
      </ItemIconWithToolTip>
    </div>
  );
}
